import { useTranslation } from 'react-i18next';
import { faPlus, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BanksForm from './BanksForm';
import DeleteModal from '@shared/components/DeleteModal';
import { useBanks } from '../hooks/useBanks';
import Table from '@shared/components/Table';

export default function BanksTable() {
    const { t } = useTranslation();
    const {
        banks,
        selectedBank,
        selectedBankId,
        modalState,
        showDeleteModal,
        pageNumber,
        pageSize,
        totalElements,
        totalPages,
        sortBy,
        sortDir,
        loading,
        error,
        handleOpenModal,
        handleCloseModal,
        handleDeleteConfirm,
        handleSaveBank,
        handleSelectBank,
        handleShowDeleteModal,
        setShowDeleteModal,
        handleSort,
        setPageNumber,
        setPageSize,
        // Form related
        register,
        handleSubmit,
        errors,
        setValue
    } = useBanks();

    const columns = [
        { key: 'bankCode', label: "BIC", sortable: true },
        { key: 'name', label: t('persons.banks.name'), sortable: true },
        { key: 'address', label: t('persons.banks.address'), sortable: true }
    ];

    const actionButtons = (
        <>
            <button
                className="icon-button"
                onClick={() => handleOpenModal('add')}
                title={t('common.add')}
            >
                <FontAwesomeIcon icon={faPlus} />
            </button>
            <button
                className={`icon-button ${!selectedBank ? 'disabled-link' : ''}`}
                onClick={() => selectedBank && handleOpenModal('edit', selectedBank)}
                title={t('common.edit')}
            >
                <FontAwesomeIcon icon={faEdit} />
            </button>
            <button
                className={`icon-button ${!selectedBank ? 'disabled-link' : ''}`}
                onClick={handleShowDeleteModal}
                disabled={!selectedBank}
                title={t('common.delete')}
            >
                <FontAwesomeIcon icon={faTrash} />
            </button>
        </>
    );

    const handleCheckboxChange = (index) => {
        const bank = banks[index];
        handleSelectBank(bank);
    };

    return (
        <>
            <Table
                // Data and state
                data={banks}
                loading={loading}
                error={error}
                selectedData={selectedBankId}
                pageNumber={pageNumber}
                pageSize={pageSize}
                sortBy={sortBy}
                sortDir={sortDir}
                totalElements={totalElements}
                totalPages={totalPages}

                // Column configuration
                columns={columns}

                // Title and actions
                title={t('persons.banks.title')}
                actionButtons={actionButtons}

                // Handlers
                handleSort={handleSort}
                handleCheckboxChange={handleCheckboxChange}
                setPageSize={setPageSize}
                setpageNumber={setPageNumber}

                // Custom renderers
                renderCell={(item, column) => {
                    if (column.key === 'address') {
                        return item[column.key] || '-';
                    }
                    return item[column.key];
                }}

                // Disable search
                showCustomSearch={true}
                customSearchComponent={null}
            />

            {modalState.visible && (
                <BanksForm
                    onClose={handleCloseModal}
                    onConfirm={handleSaveBank}
                    editData={modalState.type === 'edit' ? selectedBank : null}
                    formProps={{ register, handleSubmit, errors, setValue }}
                />
            )}

            {showDeleteModal && selectedBank && (
                <DeleteModal
                    onClose={() => setShowDeleteModal(false)}
                    onConfirm={handleDeleteConfirm}
                    name={selectedBank.name}
                    entityType="record"
                />
            )}
        </>
    );
}
